import {CompositionRectLayer, FinancingCompositionScene} from '@dms/api/shared';

import {randomLowerCaseUUID} from 'shared/web';

import {createCenteredLayerBox} from './createCenteredLayerBox';

const DEFAULT_RECT_FILL = '#0065FF';
const DEFAULT_RECT_RADIUS = 8;

export const createRectLayer = (
  canvas: Pick<FinancingCompositionScene['canvas'], 'width' | 'height'>
): CompositionRectLayer => ({
  id: randomLowerCaseUUID(),
  type: 'rect',
  ...createCenteredLayerBox(canvas, 0.4, 0.2),
  opacity: 1,
  fill: DEFAULT_RECT_FILL,
  radius: DEFAULT_RECT_RADIUS,
  stroke: null,
});
